import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { EquipmentTypeDocument, equipmentTypePullQueryBuilder } from './queryBuilder';

export function equipmentTypeFamilyMember(
  configBuilder: ConfigBuilder,
): FamilyMember<EquipmentTypeDocument> {
  const syncConfig = configBuilder<EquipmentTypeDocument>(RxdbCollectionNameV2.EQUIPMENT_TYPE);
  doNotAutoSync(syncConfig);

  pull(syncConfig, equipmentTypePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy has the sync interval at LiveInterval.MINUTES_15.
  return create(RxdbCollectionNameV2.EQUIPMENT_TYPE, replicationState);
}
